import { patronatService } from "../../services/api";
import { Case } from "../../types/services/case";

let caseList: Case[] = [
  {
    id: 1,
    name: "У разі поранення",
    text: `Ми знаємо, що отримання поранення  може бути серйозним випробуванням.
Крім фізичних ушкоджень, ви також можете стикнутися з низкою проблем, пов'язаних з юридичними питаннями, питаннями лікування та реабілітації.
Ми полегшимо цей процес та супроводимо вас на цьому шляху

<b>Першочергові дії після поранення:</b>
→	якщо ви отримали поранення в районі ведення бойових дій, то з поля бою вас евакуюють побратими або медики;
→	евакуація здійснюється до місця надання першої медичної допомоги (до медичної роти, стабілізаційного пункту або найближчого лікувального закладу);
→	під час надання домедичної допомоги у вас вилучать засоби захисту (шолом, бронежилет тощо), зброю та БК. Це матеріальні цінності, які перебувають на обліку військової частини;
→	від етапу надання домедичної допомоги у вас має бути тільки один документ – <b>Первинна медична карта (Форма 100)</b>. Збережіть цей документ! Ця форма повинна бути з вами на всіх етапах лікування;
→	за можливості перевірте правильність написання прізвища, імені та по батькові, дати народження, а також номер військової частини; 
→	у разі, якщо у військовій частині не знали про ваше лікування та помилково зарахували вас у самовільне залишення частини (СЗЧ), первинна медична карта (форма 100) та інші медичні документи (виписний епікриз), які вам нададуть в закладі охорони здоров’я, сприятимуть у вирішенні питання

<b>Після потрапляння до медичного закладу підтримуйте контакт з військовою частиною (командиром, медиками, службою супроводу) 

Контролюйте три питання: </b>
 →	за можливості  повідомляйте командиру або медикам про перебіг лікування; 
→	переконайтесь, що отримали довідку про обставини травми (поранення, контузії, каліцтва);  
→	контролюйте виплату грошового забезпечення та додаткової грошової винагороди

<b>Важливо! Довідка про обставини травми необхідна для проходження ВЛК, ЕКОПФО, для отримання виплати додаткової грошової винагороди в розмірі до 100 000 грн, а також вона впливає на розмір виплати одноразової грошової допомоги у разі встановлення інвалідності або часткової втрати працездатності</b>
    `,
    buttonText: "Детальніше про шлях пораненого",
    buttonLink: "https://navigator.pryncyp.org/injured-military",
    navigationState: "injured",
  },
  {
    id: 4,
    name: "У разі потрапляння в полон",
    text: `<b>Якщо військовослужбовець потрапив у полон:</b>
→	першочергово потрібно подати заяву про зникнення безвісти громадянина або потрапляння в полон до органів Національної поліції України. Обов'язково потрібно зафіксувати реєстраційний номер заяви, а також отримати витяг з ЄРДР, де буде зазначено ПІБ слідчого у справі. За кожним фактом зникнення, викрадення або потрапляння в полон органами досудового розслідування відкривається кримінальне провадження;
→	разом із поданням заяви про факт зникнення потрібно здати біологічний зразок для виведення ДНК-профілю. Зразки відбираються у біологічних батьків або дітей зниклої особи (для цього необхідно мати при собі паспорт та свідоцтво про народження дитини)

<b>Що потрібно зробити далі:</b>
→	зареєструватися в особистому кабінеті Координаційного штабу з питань поводження з військовополоненими та подати заяву про полон або зникнення Захисника. Після подачі заяви її статус можна відстежувати в особистому кабінеті Заявника та, за необхідності, отримувати онлайн-консультації;
→	звернутися до:
— Національного інформаційного бюро: 
Телефони: 1648; 
38 044 287 8165 (цілодобово);
Телеграм-бот: <a href="https://t.me/nib_uncp_bot" target="_blank">t.me/nib_uncp_bot</a> 
— Координаційний штаб з питань поводження з військовополоненими:
Телефони: 0 800 300 176 (Харків);
0 800 300 529 (Київ);
0 800 200 202 (Миколаїв);
0 800 200 606 (Вінниця); 
Телеграм-бот: <a href="https://t.me/Koord_shtab" target="_blank">t.me/Koord_shtab</a>
— Міжнародний Комітет Червоного Хреста: 
Гаряча лінія: +38 0800300155
— Об'єднаний центр з координації пошуку та звільнення незаконно позбавлених волі осіб внаслідок збройної агресії рф:
Телефони: +38 067 650 83 32; 
+38 098 087 36 01; 
+38 (044) 321-11-21;  
+38 09 321 11 21; 
Електронна пошта:  <a href="mailto:united.centre.ssu@gmail.com" target="_blank">united.centre.ssu@gmail.com</a>
— Бюро Центрального агентства з розшуку Міжнародного Комітету Червоного Хреста з питань, пов'язаних із міжнародним збройним конфліктом: +41 22 730 3600;
Електронна пошта: <a href="mailto:ctabureau@icrc.org" target="_blank">ctabureau@icrc.org</a>

<b>Не варто довіряти неперевіреним каналам та інформаційним ресурсам, де ворог розміщує фото чи відео начебто українських полонених військовослужбовців. Перевірте інформацію та всі деталі, зв'яжіться з уповноваженими органами та військовою частиною </b>
`,
    buttonText: "Детальніше тут",
    buttonLink: "https://navigator.pryncyp.org/family/captives",
    navigationState: "captive",
  },
  {
    id: 3,
    name: "У разі зникнення безвісти",
    text: `<b>Якщо військовослужбовець зник безвісти:</b> 
Боєць вважається зниклим безвісти якщо:
→	відсутні точні дані щодо долі військового, який не повернувся після виконання бойового завдання (побратими не можуть точно визначити, чи особа потрапила у ворожий полон чи загинула на полі бою); 
→	якщо побратими свідчать, що особа, ймовірно, потрапила в полон, але немає достатньо доказів; 
→	побратими свідчать, що особа, ймовірно, загинула, але немає можливості перевірити місце зникнення чи забрати тіло загиблого через активні бойові дії

<b>Якщо ви отримали сповіщення від ТЦК та СП, що Захисник зник безвісти за особливих обставин, потрібно:</b>
→	дізнатися останнє місце перебування Захисника та обставини зникнення (тут важливо не розповсюджувати та не публікувати в соцмережах світлини Захисника у військовій формі, локацію останнього місця його перебування (зникнення), номер військової частини, оскільки це може нашкодити Захисникові у випадку переховування чи потрапляння в полон);
→	подати заяву про розшук особи, зниклої безвісти за особливих обставин до територіального органу Нацполіції України. У заяві вказується максимально повна відома Заявнику інформація щодо Захисника та його зникнення, а саме всі відомі обставини щодо місця перебування, особливих прикмет (татуювання, шрами, пірсинг тощо), речей, які він міг би мати з собою (мобільний телефон, документи, прикраси) тощо;
→	здати біологічні зразки для порівняння ДНК-профілів;
→	через 24 години з часу подання заяви про зникнення отримати витяг з ЄРДР, де безпосередньо буде зазначено ПІБ слідчого у справі;
→	відомості, зазначені у заяві про розшук особи, зниклої безвісти за особливих обставин, підлягають внесенню до Єдиного реєстру осіб зниклих безвісти за особливих обставин;
→	зареєструватися в особистому кабінеті інформаційної системи Координаційного штабу з питань поводження з військовополоненими;
→	пройшовши верифікацію заявки, надати всю наявну інформацію про зниклу особу в розділі "Надати додаткову інформацію";
→	після подачі статус заявки та облікову категорію зниклої особи можна відстежувати в особистому кабінеті Заявника та, за необхідності, отримувати онлайн-консультації від консультантів Координаційного штабу;
→	звернутися в Об’єднаний центр з координації пошуку та звільнення незаконно позбавлених волі осіб внаслідок агресії проти України (СБУ), якщо є дані про ймовірне потрапляння військовослужбовця в полон;
→	звернутися в Національне інформаційне бюро
`,
    buttonText: "Детальніше тут",
    buttonLink: "https://navigator.pryncyp.org/family/family-of-missing",
    navigationState: "missing",
  },
  {
    id: 4,
    name: "У разі загибелі",
    text: `<b>У разі загибелі (смерті) військовослужбовця </b>
→	Командир військової частини протягом 24 годин повідомляє ТЦК та СП за місцем вашого проживання про дату і причину загибелі військовослужбовця; 
→	Представник ТЦК та СП зобов'язаний протягом 7 днів вручити вам письмове сповіщення сім’ї про загибель військовослужбовця та узгоджує з вами час, місце та деталі поховання. Також представник ТЦК та СП повинен вас проінформувати щодо порядку транспортування Героя, роз'яснити порядок надання документів для призначення виплат та пільг

<b>Як отримати свідоцтво про смерть військовослужбовця?</b>
→	після проведення судово-медичної експертизи видається  лікарське свідоцтво про смерть (форма 106/о);
→	на підстві лікарського свідоцтва про смерть ви можете звернутися до РАЦСу із заявою про державну реєстрацію смерті  та отримання свідоцтва про смерть;
→	після реєстрації смерті РАЦС видає витяг з Державного реєстру актів цивільного стану громадян про смерть для отримання допомоги на поховання

<b>Свідоцтво про смерть є підставою для отримання одноразової грошової допомоги в зв’язку із загибеллю військовослужбовця</b>
`,
    buttonText: "Детальніше про пільги та виплати",
    buttonLink: "https://navigator.pryncyp.org/family/family-of-fallen",
    navigationState: "fallen",
  },
];

export function setCaseList(newCaseList) {
  caseList = newCaseList;
}

export function getCaseList() {
  return caseList;
}
export async function loadPatronat() {
  try {
    // Call the API to get all patronat entries
    const response = await patronatService.getAll();

    // Extract the data from the response
    const newPatronatList: Case[] = response.data;

    // Sort by id before returning
    caseList = newPatronatList.sort((a, b) => a.id - b.id);
  } catch (error) {
    console.error("Failed to load patronat:", error);
    throw new Error("Не вдалося завантажити дані патронату");
  }
}
